import React from 'react'
import styled, { css } from 'styled-components'

import {
    RecipeItem,
    RecipeTitle,
    RecipePoints,
    RecipePrice,
    RecipeComposition,
    RecipeLabels,
    RecipeLabel,
} from '../../Kiosk/style'

import LabelIcons from '../../LabelIcons/LabelIcons'

const MenuWrapper = styled.div`
    display: grid;
    grid-template-columns: ${props => (props.fullSize ? '1fr' : '2fr 1fr')};
    grid-gap: 50px;
    padding: 50px 100px;
    zoom: ${props => props.zoom}; /* 1.5 */

    @media screen and (max-width: 1365px) {
        grid-template-columns: 1fr;
        padding: 5px 5px;
    }

    ${props =>
        props.print &&
        css`
            grid-template-columns: 1fr;
            padding: 2cm 1cm;
            margin-top: 2cm;
            grid-gap: 10px;
        `}

    ${props =>
        props.print &&
        props.orientation === 'portrait' &&
        css`
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            min-height: 21cm;
        `}
`

const Recipes = styled.div`
    background-color: ${props => (props.print ? '#fff' : '#eff1f1')};
    padding: 10px;

    ${props =>
        props.print &&
        props.orientation === 'landscape' &&
        css`
            display: flex;
            flex-direction: column;
            min-height: 10cm;
            justify-content: space-between;
        `}
`

const MenuRecipeItem = styled(RecipeItem)`
    grid-template-columns: 3fr 2fr 1fr;
    border-bottom: none;
`

const MenuRecipeTitle = styled(RecipeTitle)`
    grid-column: 2 span;
    border-bottom: 1px solid;
`

const MenuRecipeComposition = styled(RecipeComposition)`
    grid-column: 1 span;
    text-align: left;
`

const KioskLogo = styled.img`
    height: 60px;
    grid-row: 2 span;
    grid-column: 3;
`

const MenusWrapper = styled.div`
    background-color: #fff;
    ${props =>
        props.print &&
        css`
            border: none;
            background-color: #eff1f1;
        `}
`

const Offers = styled.div`
    padding: 10px;
    margin-bottom: 20px;

    ${props =>
        props.print &&
        css`
            border: none;
        `}
`

const OfferTitle = styled.div`
    font-size: 1.3em;
    font-weight: 600;
    text-align: left;
    border-bottom: 2px solid ${_ => _.theme.recipe_title_font_color};
    margin-bottom: 10px;
`

const MenuRecipeLabels = styled(RecipeLabels)`
    grid-column: 2;
    text-align: right;

    @media (max-width: 960px) {
        grid-column: 2 span;
        text-align: left;
    }
`

const OfferPrice = styled.div`
    text-align: right;
    font-size: 1.3em;

    span {
        padding: 2px 3px;
        span {
            margin-top: 0px;
        }
    }
`

const PrintLogo = styled.img`
    position: absolute;
    width: 2cm;
    top: 0;
    left: calc(50% - 1cm);
    top: 0.2cm;
`

const formatPrice = price => {
    const priceRegex = /(\d+)[,|.](\d+)(.*)/
    const priceMatches = priceRegex.exec(price)
    return (
        priceMatches && [
            priceMatches[1],
            priceMatches[3].trim() + priceMatches[2],
        ]
    )
}

const menuKiosk = props => {
    const { items = [] } = props
    const offer1 = [
        ...new Set(
            items
                .filter(_ => !!_.offer1_label)
                .map(_ => {
                    return {
                        name: _.offer1_label,
                        point: _.offer1_point,
                        price: formatPrice(_.offer1_price_currency),
                        kiosk: _.kiosk,
                    }
                })
        ),
    ][0]
    const offer2 = [
        ...new Set(
            items
                .filter(_ => !!_.offer2_label)
                .map(_ => {
                    return {
                        name: _.offer2_label,
                        point: _.offer2_point,
                        price: formatPrice(_.offer2_price_currency),
                        kiosk: _.kiosk,
                    }
                })
        ),
    ][0]

    const content = items.map((item, index) => (
        <MenuRecipeItem key={index}>
            <MenuRecipeTitle>
                <span>{item.menu_board_label}</span>{' '}
                {!props.hideLabels && item.label && (
                    <RecipeLabel
                        src={`img/labels/${item.label}.png`}
                        onError={i => (i.target.style.display = 'none')}
                    />
                )}
                {!props.hideLabels && item.caracteristique_produit && (
                    <RecipeLabel
                        src={`img/labels/${item.caracteristique_produit}.png`}
                        onError={i => (i.target.style.display = 'none')}
                    />
                )}
            </MenuRecipeTitle>

            <KioskLogo
                src={`img/concept/${props.concept}/kiosk/${item.kiosk_code}/menu_eco.png`}
                alt={props.name}
            />

            {!props.hideComposition && !!item.composition ? (
                <MenuRecipeComposition>
                    {item.composition}
                </MenuRecipeComposition>
            ) : null}

            {!props.hideLabels && (
                <MenuRecipeLabels>
                    <LabelIcons item={item} size="24px" />
                </MenuRecipeLabels>
            )}
        </MenuRecipeItem>
    ))

    const menuOffer = offer => (
        <Offers print={props.print}>
            <OfferTitle>{offer.name}</OfferTitle>
            <OfferPrice>
                {!props.hideRecipePoints && offer.points && (
                    <RecipePoints>{offer.points}</RecipePoints>
                )}
                {!props.hideMenuPrice && offer.price && (
                    <RecipePrice>
                        <span>
                            {offer.price[0]}
                            <span>{offer.price[1]}</span>
                        </span>
                    </RecipePrice>
                )}
            </OfferPrice>
            )}
        </Offers>
    )

    return (
        <MenuWrapper
            print={props.print}
            orientation={props.orientation}
            zoom={props.zoom}
            fullSize={props.hideMenuPrice}
        >
            {props.print && (
                <PrintLogo
                    src={`img/concept/${props.concept}/menu/${props.menu}/logo.png?_=9edb01b`}
                    alt={props.menu}
                />
            )}

            <Recipes print={props.print} orientation={props.orientation}>
                {content}
            </Recipes>

            {props.hideMenuPrice == false && (
                <MenusWrapper print={props.print}>
                    {offer1 && menuOffer(offer1)}
                    {offer2 && menuOffer(offer2)}
                </MenusWrapper>
            )}
        </MenuWrapper>
    )
}

export default menuKiosk
